(function () {
  'use strict';

  var GROUND = 'rgba(255, 255, 255, 0.8)';
  var BLUR = 'blur(10px) saturate(1.4)';
  var MARK = '#101010';
  var MARK_SOFT = 'rgba(16, 16, 16, 0.7)';

  var SHADOW =
    '0 1px 2px rgba(16,16,16,.022),' +
    '0 3px 6px rgba(16,16,16,.028),' +
    '0 8px 16px rgba(16,16,16,.034),' +
    '0 16px 32px rgba(16,16,16,.04),' +
    '0 32px 64px rgba(16,16,16,.046)';

  if (typeof CSSStyleSheet !== 'function' ||
      typeof Document === 'undefined' ||
      !('adoptedStyleSheets' in Document.prototype)) {
    document.documentElement.classList.add('sp-chat-ready');
    return;
  }

  var patched = false;

  var docEl = document.documentElement;
  function reveal() { docEl.classList.add('sp-chat-ready'); }
  setTimeout(reveal, 8000);

  var revealing = false;
  function maybeReveal(act) {
    if (revealing || docEl.classList.contains('sp-chat-ready')) return;
    var r = act.getBoundingClientRect();
    if (!r.height || act.getRootNode().adoptedStyleSheets.indexOf(sheet) === -1) return;
    if (Math.round(r.height) !== 50) return;
    revealing = true;
    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    fontsReady.then(function () {
      var last = null, still = 0;
      (function check() {
        if (docEl.classList.contains('sp-chat-ready')) return;
        var a = activator();
        var h = host();
        if (!a || Math.round(a.getBoundingClientRect().height) !== 50) { revealing = false; return; }
        var v = (h && h.style.getPropertyValue('--sp-chat-lift')) + '|' + Math.round(a.getBoundingClientRect().top);
        still = v === last ? still + 1 : 0;
        last = v;
        if (still >= 6) reveal(); else requestAnimationFrame(check);
      })();
    });
  }

  function parseRGB(value) {
    var m = String(value).match(/(-?[\d.]+)[\s,]+(-?[\d.]+)[\s,]+(-?[\d.]+)/);
    if (!m) return null;
    var n = [+m[1], +m[2], +m[3]];

    if (/^color\(/.test(String(value).trim())) n = n.map(function (c) { return c * 255; });
    return n;
  }

  function luminance(rgb) {
    var c = rgb.map(function (v) {
      v = v / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }

  function host() { return document.querySelector('shopify-chat'); }

  function activator() {
    var h = host();
    if (!h || !h.shadowRoot) return null;
    var a = h.shadowRoot.querySelector('button.activator');
    if (a) return a;
    var rt = h.shadowRoot.querySelector('shopify-agent-runtime');
    return rt && rt.shadowRoot ? rt.shadowRoot.querySelector('button.activator, [part~="activator"]') : null;
  }

  var sheet = null;
  var watched = typeof WeakSet === 'function' ? new WeakSet() : null;
  function ensure(root) {
    if (!root || !sheet) return;
    var list = root.adoptedStyleSheets;
    if (list.indexOf(sheet) === -1) root.adoptedStyleSheets = list.concat(sheet);
  }
  function watch(root) {
    if (!root || !watched || watched.has(root) || typeof MutationObserver !== 'function') return;
    watched.add(root);
    new MutationObserver(function () { var a = activator(); if (a) ensure(a.getRootNode()); })
      .observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function apply() {
    var act = activator();
    if (!act) return false;
    if (patched) { ensure(act.getRootNode()); watch(act.getRootNode()); maybeReveal(act); return true; }

    var rgb = parseRGB(getComputedStyle(act).backgroundColor);
    if (rgb && luminance(rgb) >= 0.5) {

    }

    var root = act.getRootNode();
    sheet = new CSSStyleSheet();
    sheet.replaceSync(
      'button.activator, button.activator.activator--inverted-colors {' +
      '  background-color: ' + GROUND + ' !important;' +
      '  color: ' + MARK + ' !important;' +
      '  -webkit-backdrop-filter: ' + BLUR + ' !important;' +
      '  backdrop-filter: ' + BLUR + ' !important;' +

      '  border: 1px solid #ffffff !important;' +
      '  box-shadow: ' + SHADOW + ' !important;' +
      '}' +

      'button.activator, button.activator.activator--inverted-colors {' +
      '  box-sizing: border-box !important;' +
      '  height: 50px !important;' +
      '  padding: 0 11px !important;' +
      '  gap: 8px !important;' +
      '  border-radius: 999px !important;' +
      '}' +

      'button.activator .activator__icon {' +
      '  width: 20px !important;' +
      '  height: 20px !important;' +
      '  background: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M16.4%203H3.6C3.17565%203%202.76869%203.16932%202.46863%203.47072C2.16857%203.77212%202%204.1809%202%204.60714V13.1786C2%2013.6048%202.16857%2014.0136%202.46863%2014.315C2.76869%2014.6164%203.17565%2014.7857%203.6%2014.7857H6.26667V18L10.1781%2014.7857H16.4C16.8243%2014.7857%2017.2313%2014.6164%2017.5314%2014.315C17.8314%2014.0136%2018%2013.6048%2018%2013.1786V4.60714C18%204.1809%2017.8314%203.77212%2017.5314%203.47072C17.2313%203.16932%2016.8243%203%2016.4%203Z%22%20fill%3D%22%23D3CBBF%22%20stroke%3D%22%23212121%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E") center / 20px 20px no-repeat !important;' +
      '}' +

      'button.activator .activator__icon shopify-chat-icon { display: none !important; }' +
      'button.activator .activator__icon svg { display: none !important; }' +
      'button.activator .activator__label {' +
      '  font-family: var(--sp-font-family, "Manrope", sans-serif) !important;' +
      '  font-size: 15px !important;' +
      '  font-weight: 500 !important;' +
      '  line-height: 20px !important;' +
      '  letter-spacing: 0 !important;' +
      '}' +

      'button.activator .activator__icon,' +
      'button.activator .activator__icon svg,' +
      'button.activator .activator__icon path {' +
      '  color: ' + MARK_SOFT + ' !important;' +
      '  stroke: ' + MARK_SOFT + ' !important;' +
      '}' +
      'button.activator .activator__label,' +
      'button.activator .activator__indicator {' +
      '  color: ' + MARK + ' !important;' +
      '}' +

      'button.activator {' +
      '  translate: calc(-1 * var(--sp-chat-inset-end, 0px))' +
      '             calc(-1 * var(--sp-chat-lift, 0px)) !important;' +

      '  transition: translate var(--sp-chat-glide, var(--sp-dur-3, 320ms)) var(--sp-ease-out, cubic-bezier(0.22, 1, 0.36, 1)) !important;' +
      '  will-change: translate;' +
      '}' +

      '.activator-nudge { pointer-events: none !important; }' +
      '.activator-nudge button.activator { pointer-events: auto !important; }' +

      (document.documentElement.classList.contains('sp-no-pbar') ? '.activator-nudge { bottom: 20px !important; }' : '') +
      '@media (prefers-reduced-motion: reduce) {' +
      '  button.activator { transition: none !important; }' +
      '}'
    );
    ensure(root);
    watch(root);
    watch(host().shadowRoot);

    document.documentElement.classList.add('sp-chat-lift-composited');
    patched = true;
    maybeReveal(act);
    return true;
  }

  function start() {

    apply();
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      apply();
      if (tries > 100) {
        clearInterval(timer);
        var slow = 0;
        var t2 = setInterval(function () { apply(); if (++slow > 15) clearInterval(t2); }, 2000);
      }
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
